import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export const DmsAnalyticsBody = ({ children, sx, ...props }) => {
    return (
        <Box
            sx={{
                p: 2,
                flex: 1,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    );
};

DmsAnalyticsBody.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object,
};
